import { EventEmitter, InjectionToken, Type } from '@angular/core';

export interface ComponentType {
  componentType: Type<{
    data: any;
    eventAction: EventEmitter<any>;
  }>;
}

export const DETAIL_COMPONENT = new InjectionToken<ComponentType>(
  'DETAIL_COMPONENT'
);
export const ACTION_CELL_COMPONENT = new InjectionToken<ComponentType>(
  'DETAIL_COMPONENT'
);
